import { useState, useEffect } from 'react';
import seoAiService, { LivePositionResult } from '@/services/seoAi';

export function useLivePosition(keyword: string | undefined, siteUrl: string | null) {
  const [livePosition, setLivePosition] = useState<LivePositionResult | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!keyword || !siteUrl || livePosition) return;
    setIsLoading(true);
    seoAiService
      .checkLivePosition({ keyword, siteUrl })
      .then((result) => setLivePosition(result))
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, [keyword, siteUrl, livePosition]);

  return { livePosition, isLoading };
}
